<script setup lang="ts">
import { computed } from "vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const qrValue = computed(() => `${window.location.origin}/app-share`);
</script>

<template>
  <section class="footer-app">
    <div class="footer-app__qr">
      <VueQrcode
        :value="qrValue"
        tag="svg"
        :options="{ width: 90, margin: 0, errorCorrectionLevel: 'H' }"
      />
    </div>
    <div class="footer-app__info">
      <p>{{ t("footer.qr") }}</p>
      <div class="footer-app__links">
        <a
          href="https://play.google.com/store/apps/details?id=com.royalclub.rcpay&hl=ru"
          target="_blank"
        >
          <img src="@/assets/icons/google-play.svg" alt="" />
        </a>
        <a href="https://apps.apple.com/us/app/rc-pay/id1553062417">
          <img src="@/assets/icons/app-store.svg" alt="" />
        </a>
        <a
          href="https://www.rustore.ru/catalog/app/com.royalclub.rcpay"
          target="_blank"
        >
          <img src="@/assets/icons/ru-store.svg" alt="" />
        </a>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.footer-app {
  display: grid;
  grid-template-columns: 106px auto;
  gap: calc($base-space * 3);
  align-items: center;

  &__qr {
    width: 106px;
    height: 106px;
    border-radius: 12px;
    background: var(--color-semantic-background-normal-bg-primary);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__info {
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: calc($base-space * 4);

    > p {
      @include caption();
      color: var(--color-semantic-content-normal-contrast-secondary);
      max-width: 162px;
    }
  }

  &__links {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: calc($base-space * 2);

    > a {
      width: 24px;
      height: 24px;
      background-color: var(--color-semantic-content-normal-contrast-secondary);
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.1s ease-out;

      &:hover {
        background-color: var(--color-semantic-content-normal-contrast-primary);
      }
    }
  }
}
</style>
